<template>
    <h1>GENERAL ERROR PAGE</h1>
</template>
